// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_OH5r7","foot_link":"index_foot_link_aE8Hq","list":"index_list_6SbJi","link":"index_link_pRI7b","copyright":"index_copyright_JF1Ua"};